module.exports = __webpack_public_path__ + "img/CZ47115378.57bf65c9.png";